import React from "react";
import {AucklandDonutCluster} from "./AucklandDonutCluster";
import {useNavigate} from "react-router-dom";

export function AucklandPoints() {
  const navigate = useNavigate()


  return <AucklandDonutCluster onClick={(id: string) => navigate({pathname: `/search/${id}`,})} />
}